<template>
    <div :class="statusClass">
        <h5 :class="titleClass">
            {{ titleText }}
        </h5>
        <p :class="descriptionClass">
            <slot v-if="showDescriptionText" name="description">
                {{ descriptionText }}
            </slot>
            <span v-if="descriptionTextStrikethrough" style="text-decoration: line-through">
                {{ descriptionTextStrikethrough }}
            </span>
        </p>
    </div>
</template>

<script>
    import ReferralStatusMixin from 'mixins/ReferralStatusMixin'
    import ReferralStatusEnum from '@/enums/ReferralStatusEnum'

    export default {
        mixins: [ReferralStatusMixin],

        props: {
            referral: { type: Object, required: true },
            isInline: { type: Boolean, default: false },
            description: { type: String, default: null },
            descriptionStrike: { type: String, default: null },
            showDescriptionText: { type: Boolean, default: true },
        },

        computed: {
            statusClass() {
                return {
                    'tracking-status': true,
                    'tracking-status--is-inline': this.isInline,
                }
            },

            isPending() {
                return this.isReferralPending(this.referral)
            },

            isPendingReschedule() {
                return this.isReferralPendingReschedule(this.referral)
            },

            isToBeRescheduled() {
                return this.isReferralToBeRescheduled(this.referral)
            },

            isOk() {
                return this.isReferralOk(this.referral)
            },

            isCompleted() {
                return this.isReferralCompleted(this.referral)
            },

            isError() {
                return this.isReferralError(this.referral)
            },

            titleClass() {
                return {
                    'tracking-status__title': true,
                    'tracking-status__title--color-orange': this.isPending || this.isToBeRescheduled || this.isPendingReschedule,
                    'tracking-status__title--color-blue': this.isCompleted,
                    'tracking-status__title--color-green': this.isOk,
                    'tracking-status__title--color-red': this.isError,
                }
            },

            titleText() {
                return this.$t(`pages.referrals.tracking.status_title.${this.referral.status}`)
            },

            descriptionClass() {
                return {
                    'tracking-status__description': true,
                    'tracking-status__description--color-yellow':
                        !!this.descriptionText &&
                        (this.referral.status === ReferralStatusEnum.RESCHEDULE_REQUESTED ||
                            this.referral.status === ReferralStatusEnum.RESCHEDULE_AVAILABILITY_CHANGE ||
                            this.referral.status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING ||
                            this.referral.status === ReferralStatusEnum.INSURANCE_AUTH_PENDING),
                }
            },

            descriptionText() {
                if (this.$route.path === '/referrals/received') {
                    if (this.description) return this.description
                    return this.$t(`pages.referrals.tracking.status_description.${this.referral.status}`)
                }

                return ''
            },

            descriptionTextStrikethrough() {
                if (this.descriptionStrike) return this.descriptionStrike
                else return ''
            },
        },
    }
</script>
